// extracted by mini-css-extract-plugin
export var actionText = "_j5-4";
export var container = "_j5-0";
export var leftSection = "_j5-1";
export var rightSection = "_j5-2";
export var settingsButton = "_j5-6";
export var settingsIcon = "_j5-7";
export var shortcut = "_j5-5";
export var shortcutGroup = "_j5-3";